import React from "react";
import { cn } from "@/lib/utils";

type Props = {
  /** Series of values, oldest → newest. */
  data: number[];
  className?: string;
};

const MIN_H = 5;
const MAX_H = 16; // within the 18px-tall .vb-spark track

/** Tiny bar sparkline (run-over-run trend), ported from the prototype's
 *  `.spark` (vertical bars; the latest bar is highlighted via `.on`). */
export function Sparkline({ data, className }: Props) {
  if (data.length === 0) {
    return <span className={cn("vb-spark", className)} aria-hidden="true" />;
  }
  const min = Math.min(...data);
  const max = Math.max(...data);
  const span = max - min || 1;
  const last = data.length - 1;

  return (
    <span className={cn("vb-spark", className)} aria-hidden="true">
      {data.map((v, i) => {
        const h = MIN_H + ((v - min) / span) * (MAX_H - MIN_H);
        return <i key={i} className={i === last ? "on" : undefined} style={{ height: `${h.toFixed(1)}px` }} />;
      })}
    </span>
  );
}

export default Sparkline;
